import React from 'react'
import './technology.css';
import IphoneCanvas from '../../component/iphoneComponent/iphoneCanvas';
import BannerAd from '../../images/technology/banner.jpeg';
import VideoAd from '../../images/technology/video.jpeg';
import Interstial from '../../images/technology/interstitial.jpeg';
import PlayableAd from '../../images/technology/playable.jpeg';
import NativeAd from '../../images/technology/native.jpeg';

const TechnologyComponent = () => {

    var clientScreenSize = document.body.clientWidth
    
    const getHeader = () => {
        if(clientScreenSize>800){
            return 'AppVertise Studio supports'
        }
        else{
            return <div style={{display:'flex',justifyContent:'center',textAlign:'center'}}>AppVertise Studio <br/> supports</div>
        }
    }
    return (
        <div className='technologyContainer' id='studio'>
            <div className='solutionHeaderBorder'>
                <div className='solutionHeader'>
                    {getHeader()}
                    <br/>
                </div>
                <div className='subinfo' style={{textAlign:'center',fontSize:'20px',color:'rgb(210,210,210)'}}>
                    all leading ad formats for mobile programmatic for you to scale your 
                    campaigns accross the globe
                </div>                
            </div>
            <div className='studioFlex'>
                <div className='adItem'>
                    <IphoneCanvas perspective={clientScreenSize>800 ? [1, 0, -3.7] : [0, 0, -4]} image={BannerAd}/>
                    <div className='adItemText'>Banner</div>
                </div>
                <div className='adItem'>
                    <IphoneCanvas perspective={clientScreenSize>800 ? [0.8, 0, -4.1] : [0, 0, -4]} image={VideoAd}/>
                    <div className='adItemText'>Video</div>
                </div>
                <div className='adItem'>
                    <IphoneCanvas perspective={clientScreenSize>800 ? [0, 0, -4.3] : [0, 0, -4]} image={Interstial}/>
                    <div className='adItemText'>Interstitial</div>
                </div>
                <div className='adItem'>
                    <IphoneCanvas perspective={clientScreenSize>800 ? [-0.8, 0, -4.1] : [0, 0, -4]} image={PlayableAd}/>
                    <div className='adItemText'>Playable</div>
                </div>
                <div className='adItem'>
                    <IphoneCanvas perspective={clientScreenSize>800 ? [-1, 0, -3.7] : [0, 0, -4]} image={NativeAd}/>
                    <div className='adItemText'>Native</div>
                </div>
            </div>

            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
        </div>
    )
}

export default TechnologyComponent